<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelCentro"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject', 'empresaSelected'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_centro_de_custo', null);
        return;
      }
      this.isObject
        ? this.$emit('selectChange', 'id_centro_de_custo', e)
        : this.$emit('selectChange', 'id_centro_de_custo', e.id);
      this.$emit('focus');
    },
    labelCentro({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value) {
        if (this.isObject) {
          this.selected = this.options.find((option) => option.id === value.id);
        } else {
          this.selected = this.options.find((option) => option.id === value);
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.onChange(this.selected);
      this.$emit('input', this.selected);
    },
    async setOptions(filtros) {
      this.isLoading = true;
      let filtro = `business_logic.centro_de_custo.id_empresa=${this.$store.state.user.info.id_empresa} `;
      if (filtros && filtros.empresaId) filtro = `business_logic.centro_de_custo.id_empresa=${filtros.empresaId} `;
      if (this.$store.state.user.info.localidades) {
        const filtroIdCC = await this.getIDsCC();
        if (filtroIdCC) filtro += ` AND business_logic.centro_de_custo.id in (${filtroIdCC}) `;
      }

      this.$atenaList
        .getCommon('centro_de_custo', { columns: 'id, nome', filter: filtro, order: 'nome' })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.nameField) {
            this.setValue(this.nameField);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    async getIDsCC() {
      let filter = '';
      await this.$atenaList
        .getCommon('localidade', {
          columns: 'id_centro_de_custo',
          filter: `business_logic.localidade.id in (${this.$store.state.user.info.localidades})`
        })
        .then((res) => {
          res.data?.forEach((el, index) => {
            if (index > 0) filter += ',';
            filter += el.id_centro_de_custo;
          });
        })
        .catch((err) => {
          console.log(err);
        });
      return filter;
    },
    getCentroDeCustoWithFilter() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('centro_de_custo', { columns: 'id, nome', filter: this.filter, order: 'nome' })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.nameField) {
            this.setValue(this.nameField);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  watch: {
    nameField(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.options.length > 0) {
          this.setValue(this.nameField);
        } else {
          this.setOptions();
        }
      }
    },
    empresaSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ empresaId: newVal });
      }
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
